import React, { useEffect, useState, useContext } from "react";
import useForm from "../../../../services/UseForm";
import '../../../../css/popUpForm.css';
import '../../../../css/temOrder.css';
import axios from "axios";
import { API } from "../../../../services/api";
import { PurchaseOrderContext } from "../purchaseOrder";

axios.defaults.baseURL = API;

function TemOrderByName(props) {

    const {dataList, showData, setShowData} = useContext(PurchaseOrderContext);

    const [ProductList, setProductList] = useState();

    const handleInputChange = event => {
        const { name, value } = event.target;
        if(value) 
            handleChange(name, value);
        else
            handleChange("Quantity", 1);
    };

    // const SearchProductByLaoName = event => {
    //     const { value } = event.target;
    //     if(value){
    //         setProductList([]);
    //         var results = [];
    //         results = dataList.filter((data) => {
    //             return data.LaoName.toLowerCase().includes(value.toLowerCase())
    //         });
    //         if (results) 
    //             setProductList(results);
    //         else 
    //             setProductList([]);
    //     } else {
    //         setProductList([]);
    //     }
    // }

    async function SearchProductByLaoName (event) {
        const { name, value } = event.target;
        if(value){
          handleChange(name, value);
          let token = localStorage.getItem("token");
          await axios.put(`/SearchProductByLaoName/${value}`, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            let productData = response?.data;
            if(productData.length > 0){
                setProductList(productData);
            } else {
                setProductList([]);
            }
          }).catch((err) => {
            setProductList([]);
          });
        } else {
            handleChange(name, "");
            setProductList([]);
        }
      }


    // const SearchProductByEngName = event => {
    //     const { value } = event.target;
    //     if(value){
    //         setProductList([]);
    //         var results = [];
    //         results = dataList.filter((data) => {
    //             return data.EngName.toLowerCase().includes(value.toLowerCase())
    //         });
    //         if (results) 
    //             setProductList(results);
    //         else 
    //             setProductList([]);
    //     } else {
    //         setProductList([]);
    //     }
    // }

    async function SearchProductByEngName (event) {
        const { name, value } = event.target;
        if(value){
            console.log(name, value);
            handleChange(name, value);
          let token = localStorage.getItem("token");
          await axios.put(`/SearchProductByEngName/${value}`, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            let productData = response?.data;
            if(productData.length > 0){
                setProductList(productData);
            } else {
                setProductList([]);
            }
          }).catch((err) => {
            setProductList([]);
          });
        } else {
            handleChange(name, "");
            setProductList([]);
        }
    }

    const addTemOrder = (ProductID, Barcode, LaoName, EngName, BuyPrice, ProductType) => {
        var c =0;
        for (var i=0; i < showData.length; i++) {
            if (showData[i].Barcode == Barcode) {
                showData[i].Quantity = Number(showData[i].Quantity) + Number(values.Quantity);
                showData[i].SubTotal = Number(showData[i].Quantity) * Number(showData[i].BuyPrice);
                localStorage.setItem("purchaseOrderData", JSON.stringify(showData));
                c = 1;
                break;
            }
        }  
        if(c === 0){
            var SubTotal = BuyPrice;
            if(values.Quantity > 1){
                SubTotal = Number(values.Quantity) * Number(BuyPrice);
            }
            var list = {
                ProductID: ProductID,
                Barcode: Barcode,
                EngName: EngName,
                LaoName: LaoName,
                BuyPrice: BuyPrice,
                Quantity: values.Quantity,
                SubTotal: SubTotal,
                ProductType: ProductType,
            }
            showData.push(list);
            localStorage.setItem("purchaseOrderData", JSON.stringify(showData));
        }
        setOrderList();
    }

    const setOrderList = () => {
        let userData = localStorage.getItem("purchaseOrderData");
        if (userData) {
            let userRole = JSON.parse(userData);
            setShowData(userRole);
            setProductList([]);
        } else
            setShowData([]);
    }

    const {
        values,
        handleChange,
    } = useForm();

    useEffect(() => {
        handleChange("Quantity", 1);
    }, []);

    return (
        <div style={{ display: props && props.show ? 'flex' : 'none' }} className="popUpForm">
            <div className="TempForm">
                <div className="txtSearch">
                        <div className="txt">
                            <span>ຄົ້ນຫາດ້ວຍຊື້ພາສາລາວ</span>
                            <input className="input form-control"  type="text" name="LaoName" placeholder="ຄົ້ນຫາ" onChange={(e) => SearchProductByLaoName(e)} value={values.LaoName} />
                        </div>
                        <div className="txt">
                            <span>ຄົ້ນຫາດ້ວຍຊື່ພາສາອັງກິດ</span>
                            <input className="input form-control"  type="text" name="EngName" placeholder="ຄົ້ນຫາ" onChange={(e) => SearchProductByEngName(e)} value={values.EngName} />
                        </div>
                        <div className="Quantity">
                            <span>ຈຳນວນ</span>
                            <input className="input form-control"  type="text" name="Quantity" placeholder="1" onChange={(e) => handleInputChange(e)} value={values.Quantity || ''} required />
                        </div>
                        <button type="button" onClick={(e) => props.onClick(false)} className="btn btn-danger btnBack" data-dismiss="modal" aria-label="Close">
                            ກັບຄືນ
                        </button>
                </div>
                <div className="TempContent">
                    {
                        ProductList && ProductList.map((x, y) => {
                            return (
                                <div key={y} className="TempItem" >
                                    <div className="TempBody">
                                        <div className="productName">
                                            <span>{(y+1) + '.'} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {x.LaoName}</span>
                                        </div>
                                        <div className="btnAdd"> 
                                            <button className="btn btn-success btnAdd" onClick={() => addTemOrder(x.ProductID, x.Barcode, x.LaoName, x.EngName, x.BuyPrice, x.ProductType )} >ເພີ່ມ</button>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div >
        </div>
    );
};

export default TemOrderByName;
